function WhyChoose({url}) {
  return (
    <section className="section why-choose lazyload" data-bgset="https://s3.amazonaws.com/cdn.fanduel.com/images/2024/mlb/sportsbook-search-mlb-promo/why-choose-bg.jpg">
      <div className="grid-container">
        <div className="grid-x grid-padding-x">
          <div className="small-12 small-offset-0 medium-10 medium-offset-1 cell">
            <h2 className="fanduel__h2">Why Choose FANDUEL</h2>
            <img className="lazyload" data-src="https://s3.amazonaws.com/cdn.fanduel.com/images/2024/mlb/sportsbook-search-mlb-promo/americas-1-sportsbook.png" alt="America's #1 Sportsbook"/>
          </div>
          <div className="small-12 small-offset-0 medium-10 medium-offset-1 large-8 large-offset-2 cell">
            <div className="why-choose__content">
              <p className="fanduel__p"><b>Safe & Secure</b><br/>FanDuel Sportsbook is the #1 regulated online legal betting platform. We pride ourselves on the safety and security of our customers.</p>
              <p className="fanduel__p"><b>Make Every Moment More</b><br/>Moneylines, point spreads, player props, and Same Game Parlays add even more fun and excitement to the game and are just a few of the ways customers can win real cash on FanDuel.</p>
              <p className="fanduel__p"><b>Easy Deposits, Fast Withdrawals</b><br/>We accept most major payment options. And when you win, you can receive your winnings fast!</p>
              <p className="fanduel__p"><b>Exclusive Offers</b><br/>New and existing customers can take advantage of boosted odds and the best promotions.</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default WhyChoose;
